import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationsState } from '../../states/investigations.state';

export interface LinkInvestigationCommand {
  readonly investigationId: string;
  readonly linkedInvestigationId: string;
  readonly linkType?: string;
}
export interface LinkInvestigationResult { success: boolean; }

@Injectable({ providedIn: 'root' })
export class LinkInvestigationUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _state = inject(InvestigationsState);

  public execute(command: LinkInvestigationCommand): Observable<LinkInvestigationResult> {
    this._state.setLinkingInvestigation(true);
    this._state.setErrorLinkedInvestigations(null);
    return this._repository.linkInvestigation(command.investigationId, command.linkedInvestigationId, command.linkType).pipe(
      tap(() => { this._state.setLinkingInvestigation(false); }),
      map(() => ({ success: true })),
      catchError((error) => {
        this._state.setErrorLinkedInvestigations(error.message || 'Failed to link investigation');
        this._state.setLinkingInvestigation(false);
        return throwError(() => error);
      }),
    );
  }
}
